export const TargetType = Object.freeze({
  GUEST: 0 as number,
  LOGIN: 10 as number,
  PARTNER: 15 as number,
  EMPLOYEE: 20 as number,
});

export type TARGET_TYPE = 0 | 10 | 15 | 20;

export const getTargetTypeLangKey = (value: number) => {
  switch (value) {
    case TargetType.EMPLOYEE:
      return 'I18N_FILTER_EMPLOYEE';
    case TargetType.LOGIN:
      return 'I18N_FILTER_LOGIN';
    case TargetType.PARTNER:
      return 'I18N_FILTER_PARTNER';
    case TargetType.GUEST:
      return 'I18N_FILTER_GUEST';
    default:
      return '';
  }
};
